import {MachineCopySettings} from '@models/machine/machine-copy-settings';

export class ImportSettings {
    copySettings: MachineCopySettings = new MachineCopySettings();
    category: string = '';
    organization: number = -1;
    group: string = '';
    machineType: string = '';
}